<template>
	<div>
		<div class="modal" @click.self="close">
			<div>
				<div>
					<transition name="fade">
						<div class="modalbusyoverlay" v-if="isAppBusyModal">
							<div class="busyloader"><div><div></div><div></div><div></div><div></div></div></div>
						</div>
					</transition>
					<div>
						<a data-ic="R" data-href @click.prevent="logout">
							Log ud
						</a>
						<h3 v-text="dialogTitle">
							Profil
						</h3>
					</div>
					<section>
						<div>
							<form ref="form" @submit.prevent autocomplete="off">
								<div class="form-groups">
									<div class="form-group">
										<div class="input-group" ref="emailgroup">
											<label for="email">
												Email
											</label>
											<input v-model="email" id="email" type="email" ref="email" value autocomplete="off">
										</div>

										<div class="input-group" ref="phonenumbergroup">
											<label for="phonenumber">
												Telefonnummer
											</label>
											<input v-model="phonenumber" id="phonenumber" type="number" ref="phonenumber" value autocomplete="off">
										</div>

									</div>
									<div class="form-group">

										<div class="input-group" ref="currentPasswordgroup">
											<label for="currentpassword">
												Eksisterende kodeord
											</label>
											<input v-model="currentPassword" id="currentpassword" type="password" ref="currentPassword" value autocomplete="new-password">
										</div>

										<div class="input-group" ref="newPasswordgroup">
											<label for="newpassword">
												Nyt kodeord
											</label>
											<input v-model="newPassword" id="newpassword" type="password" ref="newPassword" value autocomplete="new-password">
										</div>

										<div class="input-group" ref="repeatPasswordgroup">
											<label for="repeatpassword">
												Gentag nyt kodeord
											</label>
											<input v-model="repeatPassword" id="repeatpassword" type="password" ref="repeatPassword" value autocomplete="new-password">
										</div>
									</div>
								</div>
								<div class="divider"></div>
								<div class="buttons-group">
									<button type="button" @click.prevent="close" class="text space" >
										Tilbage
									</button>
									<button type="button" @click.prevent="save">
										Gem
									</button>
								</div>
							</form>
						</div>
					</section>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import { types } from "@/app/types/types";
	import { appFeedbackStateEnum } from "@/app/enums/common";

	export default {
		name: "ModalProfileEdit",
		data()
		{
			return {
				dialogTitle: "Profil",
				user: null,
				currentUser: null,
				email: null,
				phonenumber: null,
				currentPassword: null,
				newPassword: null,
				repeatPassword: null
			}
		},
		mounted()
		{
			this.setModalIsVisible()
			this.loadData()
		},
		destroyed()
		{
			this.setModalNotVisible()
		},
		methods:
		{
			checkForChanges()
			{
				var changes = false

				if (this.email != this.currentUser.email)
				{
					changes = true
				}

				if (this.phonenumber != this.user.phonenumber)
				{
					changes = true
				}

				if (this.newPassword && this.newPassword.length > 0)
				{
					changes = true
				}

				if (changes)
				{
					return !confirm("Der er ændringer der ikke er gemt. Vil du lukke dialogen?")
				}

				return false;
			},
			close()
			{
				if (this.checkForChanges())
				{
					return;
				}

				this.setModalProfileEditVisibility(false)
			},
			logout(checkforChanges = true)
			{
				if (checkforChanges && this.checkForChanges())
				{
					return;
				}

				this.setAppAsBusyModal();
				this.$store.dispatch(types.ACTION_LOGOUT_USER)
				this.setModalProfileEditVisibility(false)
				this.setAppAsIdle();
			},
			async loadData()
			{
				this.setAppAsBusyModal();
				this.currentUser = this.$store.getters[types.GET_USER_DATA];

				try
				{
					var result = await this.$store.dispatch(types.ACTION_GET_USER, this.currentUser.id);

					if (result.status == 200)
					{
						this.user = result.data;
						this.email = result.data.email
						this.phonenumber = result.data.phonenumber
						this.dialogTitle = this.user.name
						this.setAppAsIdle();
					}
					else
					{
						this.setAppAsIdle();
						this.setModalProfileEditVisibility(false)
						log("Error: " + result.message);
						alert("Der opstod en fejl. Opdater siden og prøv igen.");
					}
				}
				catch (e)
				{
					this.setAppAsIdle();
					this.setModalProfileEditVisibility(false)
					log("Error: " + e.message);
					this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
				}
			},
			async save()
			{
				var valid = true
				var validationFocus = false

				if (!this.email || this.email.length == 0)
				{
					this.$refs.emailgroup.setAttribute("data-validation", "Indtast venligst en korrekt e-mail adresse")
					this.$refs.email.focus()
					validationFocus = true
					valid = false
				}
				else
				{
					this.$refs.emailgroup.removeAttribute("data-validation")
				}

				if (!this.phonenumber || this.phonenumber.length < 8)
				{
					this.$refs.phonenumbergroup.setAttribute("data-validation", "Indtast venligst et korrekt telefonnummer")
					valid = false

					if (!validationFocus)
					{
						this.$refs.phone.focus()
						validationFocus = true
					}
				}
				else
				{
					this.$refs.phonenumbergroup.removeAttribute("data-validation")
				}

				if ((this.newPassword && this.newPassword.length > 0) && (this.newPassword != this.repeatPassword))
				{
					this.$refs.repeatPasswordgroup.setAttribute("data-validation", "Gentag venligst det nye kodeord korrekt")
					valid = false

					if (!validationFocus)
					{
						this.$refs.repeatPassword.focus()
						validationFocus = true
					}
				}
				else
				{
					this.$refs.repeatPasswordgroup.removeAttribute("data-validation")
				}

				if ((this.newPassword && this.newPassword.length > 0) && (this.newPassword == this.repeatPassword) && (!this.currentPassword))
				{
					this.$refs.currentPasswordgroup.setAttribute("data-validation", "Indtast venligst dit nuværende kodeord")
					valid = false
				}
				else
				{
					this.$refs.currentPasswordgroup.removeAttribute("data-validation")
				}

				if (!valid)
				{
					return;
				}

				this.setAppAsBusyModal();

				try
				{
					var result = await this.$store.dispatch(types.ACTION_UPDATE_USER,
						{
							id: this.currentUser.id,
							email: this.email,
							phonenumber: this.phonenumber,
							currentpassword: this.currentPassword,
							newpassword: this.newPassword,
							repeatpassword: this.repeatPassword
						})

					if (result.status == 200)
					{
						this.setAppAsIdle();

						if (this.newPassword && this.newPassword.length > 0)
						{
							alert("Du har skiftet kodeord, og vil automatisk blive logget ud.");
							this.logout(false)
						}
						else
						{
							this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
							this.setModalProfileEditVisibility(false)
						}
					}
					else if (result.status == 400)
					{
						this.setAppAsIdle();

						if (result.data && result.data.ErrorCode && result.data.ErrorCode == "EmailInUse")
						{
							this.$refs.emailgroup.setAttribute("data-validation", "Email adressen er i brug af en anden bruger. Indtast venligst en anden.")
							this.$refs.email.focus()
						}
						else if (result.data && result.data.ErrorCode && result.data.ErrorCode == "CurrentPasswordNotCorrect")
						{
							this.$refs.currentPasswordgroup.setAttribute("data-validation", "Det nuværende kodeord er ikke korrekt.")
							if (!validationFocus) this.$refs.currentPassword.focus()
						}
						else if (result.data && result.data.ErrorCode && result.data.ErrorCode == "OneLowercaseLetterRequired")
						{
							this.$refs.newPasswordgroup.setAttribute("data-validation", "Minimum et lille bogstav er krævet i kodeordet.")
							this.$refs.repeatPasswordgroup.setAttribute("data-validation", "Minimum et lille bogstav er krævet i kodeordet.")
							if (!validationFocus) this.$refs.newPassword.focus()
						}
						else if (result.data && result.data.ErrorCode && result.data.ErrorCode == "OneUppercaseLetterRequired")
						{
							this.$refs.newPasswordgroup.setAttribute("data-validation", "Minimum et stort bogstav er krævet i kodeordet.")
							this.$refs.repeatPasswordgroup.setAttribute("data-validation", "Minimum et stort bogstav er krævet i kodeordet.")
							if (!validationFocus) this.$refs.newPassword.focus()
						}
						else if (result.data && result.data.ErrorCode && result.data.ErrorCode == "LengthBetween8And15Chars")
						{
							this.$refs.newPasswordgroup.setAttribute("data-validation", "Kodeordet skal være mellem 8 og 15 karakterer.")
							this.$refs.repeatPasswordgroup.setAttribute("data-validation", "Kodeordet skal være mellem 8 og 15 karakterer.")
							if (!validationFocus) this.$refs.newPassword.focus()
						}
						else if (result.data && result.data.ErrorCode && result.data.ErrorCode == "OneNumericCharRequired")
						{
							this.$refs.newPasswordgroup.setAttribute("data-validation", "Minimum et tal er krævet i kodeordet.")
							this.$refs.repeatPasswordgroup.setAttribute("data-validation", "Minimum et tal er krævet i kodeordet.")
							if (!validationFocus) this.$refs.newPassword.focus()
						}
						else if (result.data && result.data.ErrorCode && result.data.ErrorCode == "OneSpecialCharRequired")
						{
							this.$refs.newPasswordgroup.setAttribute("data-validation", "Minimum en special karakter er krævet i kodeordet.")
							this.$refs.repeatPasswordgroup.setAttribute("data-validation", "Minimum en special karakter er krævet i kodeordet.")
							if (!validationFocus) this.$refs.newPassword.focus()
						}
						else
						{
							// Tjek for brugt email
							log("Update error: " + result.data.message);
							alert("Der opstod en fejl. Opdater siden og prøv igen.");
						}
					}
					else if (result.status == 500)
					{
						log("Api error: " + result.message);
						alert("Der opstod en fejl. Opdater siden og prøv igen.");
					}

				}
				catch (e)
				{
					log("Error: " + e.message);
					this.setAppAsIdle();
					this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.");
				}
			}
		}
	};
</script>